import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './vitals.reducer';

export const VitalsDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const vitalsEntity = useAppSelector(state => state.vitals.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="vitalsDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.vitals.detail.title">Vitals</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.vitals.id">Id</Translate>
            </span>
          </dt>
          <dd>{vitalsEntity.id}</dd>
          <dt>
            <span id="systolic">
              <Translate contentKey="tinyMedicRestApp.vitals.systolic">Systolic</Translate>
            </span>
          </dt>
          <dd>{vitalsEntity.systolic}</dd>
          <dt>
            <span id="diastolic">
              <Translate contentKey="tinyMedicRestApp.vitals.diastolic">Diastolic</Translate>
            </span>
          </dt>
          <dd>{vitalsEntity.diastolic}</dd>
          <dt>
            <span id="bpMethod">
              <Translate contentKey="tinyMedicRestApp.vitals.bpMethod">Bp Method</Translate>
            </span>
          </dt>
          <dd>{vitalsEntity.bpMethod}</dd>
          <dt>
            <span id="pulse">
              <Translate contentKey="tinyMedicRestApp.vitals.pulse">Pulse</Translate>
            </span>
          </dt>
          <dd>{vitalsEntity.pulse}</dd>
          <dt>
            <span id="oximetryMethod">
              <Translate contentKey="tinyMedicRestApp.vitals.oximetryMethod">Oximetry Method</Translate>
            </span>
          </dt>
          <dd>{vitalsEntity.oximetryMethod}</dd>
          <dt>
            <span id="oximetry">
              <Translate contentKey="tinyMedicRestApp.vitals.oximetry">Oximetry</Translate>
            </span>
          </dt>
          <dd>{vitalsEntity.oximetry}</dd>
          <dt>
            <span id="respiratoryRate">
              <Translate contentKey="tinyMedicRestApp.vitals.respiratoryRate">Respiratory Rate</Translate>
            </span>
          </dt>
          <dd>{vitalsEntity.respiratoryRate}</dd>
          <dt>
            <span id="bodyTemp">
              <Translate contentKey="tinyMedicRestApp.vitals.bodyTemp">Body Temp</Translate>
            </span>
          </dt>
          <dd>{vitalsEntity.bodyTemp}</dd>
          <dt>
            <span id="bodySurfaceArea">
              <Translate contentKey="tinyMedicRestApp.vitals.bodySurfaceArea">Body Surface Area</Translate>
            </span>
          </dt>
          <dd>{vitalsEntity.bodySurfaceArea}</dd>
          <dt>
            <span id="painScore">
              <Translate contentKey="tinyMedicRestApp.vitals.painScore">Pain Score</Translate>
            </span>
          </dt>
          <dd>{vitalsEntity.painScore}</dd>
          <dt>
            <span id="liverFunction">
              <Translate contentKey="tinyMedicRestApp.vitals.liverFunction">Liver Function</Translate>
            </span>
          </dt>
          <dd>{vitalsEntity.liverFunction}</dd>
          <dt>
            <span id="gfr">
              <Translate contentKey="tinyMedicRestApp.vitals.gfr">Gfr</Translate>
            </span>
          </dt>
          <dd>{vitalsEntity.gfr}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.vitals.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{vitalsEntity.cursor}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.vitals.active">Active</Translate>
            </span>
          </dt>
          <dd>{vitalsEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.vitals.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{vitalsEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.vitals.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{vitalsEntity.timestampentry}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.vitals.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{vitalsEntity.lastupdated}</dd>
          <dt>
            <span id="weight">
              <Translate contentKey="tinyMedicRestApp.vitals.weight">Weight</Translate>
            </span>
          </dt>
          <dd>{vitalsEntity.weight}</dd>
          <dt>
            <span id="height">
              <Translate contentKey="tinyMedicRestApp.vitals.height">Height</Translate>
            </span>
          </dt>
          <dd>{vitalsEntity.height}</dd>
          <dt>
            <span id="cvp">
              <Translate contentKey="tinyMedicRestApp.vitals.cvp">Cvp</Translate>
            </span>
          </dt>
          <dd>{vitalsEntity.cvp}</dd>
          <dt>
            <span id="map">
              <Translate contentKey="tinyMedicRestApp.vitals.map">Map</Translate>
            </span>
          </dt>
          <dd>{vitalsEntity.map}</dd>
          <dt>
            <span id="intake">
              <Translate contentKey="tinyMedicRestApp.vitals.intake">Intake</Translate>
            </span>
          </dt>
          <dd>{vitalsEntity.intake}</dd>
          <dt>
            <span id="output">
              <Translate contentKey="tinyMedicRestApp.vitals.output">Output</Translate>
            </span>
          </dt>
          <dd>{vitalsEntity.output}</dd>
          <dt>
            <span id="inOutUnits">
              <Translate contentKey="tinyMedicRestApp.vitals.inOutUnits">In Out Units</Translate>
            </span>
          </dt>
          <dd>{vitalsEntity.inOutUnits}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.vitals.glucoUser">Gluco User</Translate>
          </dt>
          <dd>{vitalsEntity.glucoUser ? vitalsEntity.glucoUser.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.vitals.weightEntry">Weight Entry</Translate>
          </dt>
          <dd>{vitalsEntity.weightEntry ? vitalsEntity.weightEntry.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.vitals.glucoseEntry">Glucose Entry</Translate>
          </dt>
          <dd>{vitalsEntity.glucoseEntry ? vitalsEntity.glucoseEntry.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.vitals.appointment">Appointment</Translate>
          </dt>
          <dd>{vitalsEntity.appointment ? vitalsEntity.appointment.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.vitals.volunteerVisit">Volunteer Visit</Translate>
          </dt>
          <dd>{vitalsEntity.volunteerVisit ? vitalsEntity.volunteerVisit.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.vitals.bloodDonation">Blood Donation</Translate>
          </dt>
          <dd>{vitalsEntity.bloodDonation ? vitalsEntity.bloodDonation.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/vitals" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/vitals/${vitalsEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default VitalsDetail;
